import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { TextField, SelectField } from '../../components'
import { Button } from '../../elements'

import validate from './validate'

class AgentForm extends Component {
    static propTypes = {
        onSubmit: PropTypes.func,
    }

    render() {
        const { isSubmiting, handleSubmit, onSubmit, clients } = this.props
        let clientIds = clients.map(client => client.clientId);

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <Field
                    name="clientId"
                    label="Client Id"
                    options={clientIds}
                    disabled={isSubmiting}
                    component={SelectField}
                />
                <Field
                    name="agentId"
                    label="Agent Id"
                    disabled={isSubmiting}
                    component={TextField}
                />
                <Field
                    name="intervalSeconds"
                    label="Interval Seconds"
                    options={['1','2','3','4','5','6','8','9','10']}
                    disabled={isSubmiting}
                    component={SelectField}
                />
                <Button loading={isSubmiting} htmlType="submit" type="primary">Create</Button>
            </form>
        )
    }
}

export default reduxForm({
    form: 'agent-form',
    validate,
})(AgentForm)



// WEBPACK FOOTER //
// ./src/smart-components/agent-form/index.js